import React, { useMemo } from "react";
import GlobalCard from "../../../../../../components/GlobalCardComponent";
import { Box, Divider, Grid, IconButton, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import PurchaseTestCard from "../../../components/TestCard";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { updateTestQuantity } from "../../../../../../../redux/features/testTypecheckout/ProceedWithTestDataReducer";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import NoTestFound from "./NoTestFound";
import { useNavigate } from "react-router-dom";
export default function ShowingSelectedTest() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const defaultSelectedTestData = useSelector(
    (state) => state.selectedTestDataList.defaultTestDataList
  );

  // Calculate Total Amount
  const totalAmount = useMemo(() => {
    return defaultSelectedTestData?.reduce((acc, item) => {
      const amount = Number(item.base_price || 0);
      const qty = Number(item.quantity || 1);
      return acc + amount * qty;
    }, 0);
  }, [defaultSelectedTestData]);

  // Increment
  const handleIncrement = (index, quantity) => {
    dispatch(updateTestQuantity({ index, quantity: quantity + 1 }));
  };

  // Decrement
  const handleDecrement = (index, quantity) => {
    if (quantity > 1) {
      dispatch(updateTestQuantity({ index, quantity: quantity - 1 }));
    }
  };

  //    delete function once quantity is 1

  const handleDelete = (index) => {
    dispatch(updateTestQuantity({ index, remove: true }));
  };

  return (
    <>
      <GlobalCard height="100%">
        <Grid container spacing={2}>
          {/* Header */}
          <Grid item xs={6}>
            <Typography
              textAlign="start"
              color="#222222"
              fontFamily="Inter"
              fontSize="18px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 500 }}
            >
              Your Selected Tests
            </Typography>
          </Grid>

          <Grid item xs={6} textAlign="end">
            <Typography
              sx={{ fontSize: "14px", fontWeight: 600, color: "#555" }}
            >
              ({defaultSelectedTestData?.length} Items)
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ borderColor: " #DDDDDD" }} />
          </Grid>

          {/* Selected Test List */}

          <Grid item xs={12}>
            <Grid
              container
              spacing={2}
              sx={{
                maxHeight: "calc(100vh - 350px)", // adjust based on header/footer
                overflowY: "auto",
                pr: 1, // padding to avoid content cut by scrollbar
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#572575", // purple like your screenshot
                  borderRadius: "3px",
                },
                "&:hover::-webkit-scrollbar-thumb": {
                  backgroundColor: "#572575", // purple on hover
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f5f5f5",
                  borderRadius: "3px",
                },
              }}
            >
              {defaultSelectedTestData?.map((data, index) => (
                <Grid item xs={12} key={index}>
                  <PurchaseTestCard>
                    <Grid container spacing={1.5}>
                      {/* Image + Name */}
                      <Grid item xs={6} container alignItems="center" gap={1}>
                        <Box
                          sx={{
                            border: "1px solid #eee",
                            borderRadius: "8px",
                            padding: "6px",
                          }}
                        >
                          <img
                            src={data?.image_path?.image_src}
                            style={{ width: "32px" }}
                          />
                        </Box>

                        <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                          {data?.sub_test_type_id?.name ||
                            data?.test_type_id?.name}{" "}
                          - {data?.product_name}
                        </Typography>
                      </Grid>

                      {/* Price */}
                      <Grid item xs={6} textAlign="end">
                        <Typography
                          sx={{
                            fontSize: "18px",
                            fontWeight: 800,
                            color: "#572575",
                          }}
                        >
                          INR {data?.base_price * data?.quantity}
                        </Typography>
                      </Grid>

                      <Grid item xs={12}>
                        <Divider sx={{ borderColor: "#DDDDDD" }} />
                      </Grid>

                      {/* Info */}
                      <Grid
                        item
                        xs={10}
                        container
                        alignItems="center"
                        gap={0.5}
                      >
                        <img
                          src="/PurchaseTest/Vector (7).png"
                          style={{ width: "16px", marginLeft: "-4px" }}
                        />
                        <Typography sx={{ fontSize: "14px", color: "#333" }}>
                          Question Quantity :{" "}
                          <span style={{ fontWeight: 600 }}>
                            {data?.question_quantity}
                          </span>
                        </Typography>
                      </Grid>

                      {/* Quantity Selector */}
                      <Grid item xs={2} textAlign="end">
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            p: "4px",
                          }}
                        >
                          {data?.quantity > 1 ? (
                            <IconButton
                              size="small"
                              onClick={() =>
                                handleDecrement(index, data?.quantity)
                              }
                              sx={{
                                border: "0.5px solid #E9D0F8",
                                color: "#572575",
                                width: "22px",
                                height: "22px",
                                borderRadius: "4px",
                                background: "#ffffff",
                              }}
                            >
                              <RemoveIcon fontSize="small" />
                            </IconButton>
                          ) : (
                            <IconButton
                              size="small"
                              onClick={() => handleDelete(index)}
                              sx={{
                                border: "0.5px solid #E9D0F8",
                                color: "#572575",
                                width: "22px",
                                height: "22px",
                                borderRadius: "4px",
                                background: "#ffffff",
                              }}
                            >
                              <DeleteOutlineOutlinedIcon
                                fontSize="small"
                                style={{ fontSize: "1rem" }}
                              />
                            </IconButton>
                          )}

                          <Typography
                            sx={{
                              fontSize: "14px",
                              width: "30px",
                              textAlign: "center",
                              fontFamily: "Inter",
                              fontWeight: 500,
                              color: "#000000",
                            }}
                          >
                            {data?.quantity?.toString().padStart(2, "0")}
                          </Typography>

                          <IconButton
                            size="small"
                            onClick={() =>
                              handleIncrement(index, data?.quantity)
                            }
                            sx={{
                              border: "0.5px solid #E9D0F8",
                              color: "#572575",
                              width: "22px",
                              height: "22px",
                              borderRadius: "4px",
                              background: "#ffffff",
                            }}
                          >
                            <AddIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      </Grid>
                    </Grid>
                  </PurchaseTestCard>
                </Grid>
              ))}
            </Grid>
          </Grid>

          {/* Total Price */}
          {/* <Grid item xs={12} textAlign="end" mt={2}>
            <Typography sx={{ fontSize: "20px", fontWeight: 700 }}>
              Total Amount: INR {totalAmount}
            </Typography>
          </Grid> */}

          {defaultSelectedTestData?.length === 0 && (
            <Grid item xs={12}>
              <NoTestFound
                onClick={() => navigate("/test-prep/performance/purchase-test")}
              />
            </Grid>
          )}
        </Grid>
      </GlobalCard>
    </>
  );
}
